import styled from 'styled-components'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import { useEffect, useContext, useState } from 'react'
import { NextPage } from 'next'
import { useRouter } from 'next/router'

import { FunctionBar } from '../components/Discover/FunctionBar'
import { Page } from '../components/Page'
import { Section } from '../components/Section'
import EventItemList from '../components/Discover/EventItemList'
import { EventsContext, UserContext } from '../context'
import { icons, show } from '../utils'
import { FetchEventsParams, NookEvent } from '../types'
import { P } from '../components/P'
import { CreateEventCTABanner } from '../components/CreateEventCTABanner'
import { useAnalyticsEvent } from '../hooks/analyticsEvent'
import {
  descoverPageStyles,
  Div,
} from '../components/pageStyles/descoverPageStyles'
import { BowedHeroShortSection } from '../components/Sections/BowedHeroShortSection'
import { ExploreAll } from '../components/ExploreAll'

// Styles
const PageContainer = styled(Page)`
  ${descoverPageStyles}
`

// Discover Page.
const DiscoverPage: NextPage = () => {
  const { t } = useTranslation('common')
  // Global State
  const router = useRouter()
  const { events, hasNextPage, fetchEvents, resetCurrentEventPage } =
    useContext(EventsContext)
  const { currentUser } = useContext(UserContext)
  const analyticsEvent = useAnalyticsEvent()

  // Local State
  const [eventsToShow, setEventToShow] = useState<NookEvent[]>([])

  const { fetchPastEvents } = useContext(EventsContext)
  const [pastEvents, setPastEvents] = useState<NookEvent[]>(undefined)

  useEffect(() => {
    fetchPastEvents({}).then((pastEventsResponse) => {
      setPastEvents(pastEventsResponse.results)
    })
  }, [fetchPastEvents])

  // Calc
  const categoryFilter = router.query.category as string
  const sortByFilter = router.query.sort as string
  const paidTypeFilter = router.query.paid as string

  // Func
  const doSort = () => {
    // sorting by last added event
    const newEvents = [...events].sort(
      (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at),
    )
    if (sortByFilter) {
      switch (sortByFilter.toLowerCase()) {
        case 'title-asc': {
          newEvents.sort((a, b) => a.title.localeCompare(b.title))
          break
        }

        default:
          break
      }
    }
    setEventToShow(newEvents)
  }

  const getCategory = () => {
    let category = ''

    if (categoryFilter) {
      category = categoryFilter
    } else {
      category = 'allCategory'
    }
    return category
  }

  const fetchNextPage = () => {
    // Set Filter Params
    const params: FetchEventsParams = {
      category: getCategory(),
      search: '',
      paid_type: paidTypeFilter,
    }
    // Get next page
    void fetchEvents(params)
  }

  // Effects
  // on Filter Change fetch page
  useEffect(() => {
    // Set Filter Params
    const params: FetchEventsParams = {
      category: getCategory(),
      search: '',
      paid_type: paidTypeFilter,
      // reset: true,
    }
    // get new data
    void fetchEvents(params)

    // pin analytics
    if (categoryFilter) {
      analyticsEvent.discoverFilterByCategory(categoryFilter)
    }
  }, [categoryFilter, paidTypeFilter])

  // On Var Change do a sort operation
  useEffect(() => {
    doSort()
  }, [sortByFilter, events])

  // IDK - change something if current user is null
  useEffect(() => {
    if (currentUser === null) {
      resetCurrentEventPage(true)
    }
  }, [currentUser])

  // On Mount
  useEffect(() => {
    // Re-set page on param change
    resetCurrentEventPage(true)
    analyticsEvent.discoverDiscoverHomepage()
  }, [])

  // ..
  return (
    <PageContainer>
      <BowedHeroShortSection
        bgImage="/images/discoverHero.svg"
        smallHeader={t(
          `discover1138997445`,
          `Get inspired to host or join one of the variety of activities below.`,
        )}
        largeHeader={t(
          `discover1576797219`,
          `Discover, join or host online activities with others`,
        )}
      />
      <FunctionBar
        category={categoryFilter}
        sort={sortByFilter}
        paid={paidTypeFilter}
      />
      {/* Show List for logged-in users */}
      {/* {show(currentUser !== null) && ( */}
      <>
        <EventItemList
          eventsToShow={eventsToShow}
          firstEventIndex={0}
          page="Discover"
          showPlaceHolderWhenEmpty={true}
          placeholder={t(
            `discover-356797096`,
            `No events found matching your search`,
          )}
          numberOfMobileColumns={2}
        />

        {pastEvents?.length > 0 && (
          <ExploreAll
            header={t(`Past events`, `Past events`)}
            className="sectionContainer"
            page="features"
            events={pastEvents}
            showExploreAllCta={false}
            numberOfEventToShow={8}
            showMoreButton={true}
          />
        )}
      </>
      {/* )} */}

      {/* SHow Split list for users that are not logged in */}
      {/* {show(currentUser === null) && (
        <>
          <Div>
            <EventItemList
              eventsToShow={eventsToShow}
              firstEventIndex={0}
              numberOfEventToShow={8}
              page="Discover"
              showPlaceHolderWhenEmpty={true}
              placeholder={t(
                `discover-356797096`,
                `No events found matching your search`,
              )}
              numberOfMobileColumns={2}
            />
            {show(pastEvents && pastEvents.length > 0) && (
              <ExploreAll
                header={t(`Past events`, `Past events`)}
                className="sectionContainer"
                page="Features"
                events={pastEvents}
                showExploreAllCta={false}
                numberOfEventToShow={8}
                showMoreButton={true}
              />
            )}
            <Section className="ctaBanner">
              <CreateEventCTABanner
                bannerHeader={t(
                  `discover1189263620`,
                  `Join today for free to start hosting your own events as an individual, or business.`,
                )}
                bannerContent={t(
                  `discover-1592615292`,
                  `A place to organise, plan and host events with your friends, family and broader network.`,
                )}
                showCreateEventButton={true}
              />
            </Section>

            {eventsToShow.length > 0 && (
              <EventItemList
                eventsToShow={eventsToShow}
                firstEventIndex={8}
                page="Discover"
                numberOfMobileColumns={2}
              />
            )}
          </Div>
        </>
      )} */}
      <Section className="loadMore">
        {hasNextPage === true && (
          <Div
            onMouseDown={(e) => {
              e.preventDefault()
              fetchNextPage()
            }}>
            <P className="callout">{t(`Load more`, `Load more`)}</P>
            <img className="arrowDown" src={icons.arrowDown}></img>
          </Div>
        )}
      </Section>
    </PageContainer>
  )
}

// Export.
export default DiscoverPage
export async function getStaticProps({ locale }) {
  const translations = await serverSideTranslations(locale, ['common'])
  return {
    props: {
      ...translations,
    },
  }
}
